export default __webpack_public_path__ + "static/stars-forks-53ba34b206ac8963083291b1c1326a45.webp";